import { useParams, Navigate } from 'react-router-dom';
import { Ellie } from '../../components/Ellie';
import { useFeatureFlag } from '../../services/featureFlag.service';
import FeatureFlagService from '../../services/featureFlag.service';
import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import elliePng from '../../assets/images/pliable/ellie.png';

export default function ConversationPage() {
  const { id } = useParams<{ id: string }>();
  const isAiAssistantEnabled = useFeatureFlag('ai-assistant', false);
  const [flagsReady, setFlagsReady] = useState(() => FeatureFlagService.getInstance().isReady);

  useEffect(() => {
    if (flagsReady) return;
    FeatureFlagService.getInstance().waitForInitialization().then(() => setFlagsReady(true));
  }, [flagsReady]);

  if (!flagsReady) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAiAssistantEnabled) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="h-screen w-full flex flex-col">
      <div className="flex-shrink-0 p-4 border-b border flex items-center gap-3">
        <img src={elliePng} alt="Ellie" className="h-10 w-10 rounded-full object-cover" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">Hi, I'm Ellie</h1>
          <p className="text-sm text-muted-foreground">Your AI chief of staff — ask me about your business and get recommendations on how to change your strategy.</p>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        {id && <Ellie showHistory={true} conversationId={id} />}
      </div>
    </div>
  );
}
